import * as React from "react";
import styled from "styled-components";
import { Alert, Button } from "components/bootstrap";
import { IfPermitted, LinkContainer } from "components/common";
import useModelProviderConfig from "aiagent/hooks/useModelProviderConfig";
import { hasConfiguredModelProvider } from "aiagent/utils";
import AgentWorkflowRoutes from "../Routes";
const StyledAlert = styled(Alert)`
  margin-top: 0;
`;
const AlertContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacings.sm};
`;
const ModelProviderRequiredAlert = () => {
  const { data: modelProviderConfig, isLoading } = useModelProviderConfig();
  if (isLoading || hasConfiguredModelProvider(modelProviderConfig)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", title: "Model provider required" }, /* @__PURE__ */ React.createElement(AlertContent, null, /* @__PURE__ */ React.createElement("span", null, "Configure a model provider before starting or running AI agent workflows."), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "agent_workflow:manage" }, /* @__PURE__ */ React.createElement(LinkContainer, { to: AgentWorkflowRoutes.SETTINGS }, /* @__PURE__ */ React.createElement(Button, { bsSize: "small" }, "Configure Provider")))));
};
export default ModelProviderRequiredAlert;
